<template>
  <ui-button
    text
    small
    class="custom-service-btn"
    :class="{ 'custom-service-btn--bottom': bottom }"
    v-on="$listeners"
    >{{ label }}</ui-button
  >
</template>

<script>
export default {
  name: "GmbServiceCustomServiceAddButton",
  props: {
    label: {
      type: String,
      required: true
    },
    bottom: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="scss" scoped>
.custom-service-btn {
  ::v-deep.v-btn__content {
    color: $primary;
  }

  &--bottom {
    margin-top: $spacing * 3;
  }
}
</style>
